import { render, staticRenderFns } from "./Notification.html?vue&type=template&id=7df35ef5&scoped=true&external"
import script from "./Notification.js?vue&type=script&lang=js&external"
export * from "./Notification.js?vue&type=script&lang=js&external"
import style0 from "./Notification.scss?vue&type=style&index=0&id=7df35ef5&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df35ef5",
  null
  
)

export default component.exports